import script from "./AdminReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminReviews.vue?vue&type=script&setup=true&lang=js"

import "./AdminReviews.vue?vue&type=style&index=0&id=979d98fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-979d98fe"]])

export default __exports__